import React from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
// svg
import { ReactComponent as Deletesvg } from "assets/svg/deletesvg.svg";
import { ReactComponent as Editsvg } from "assets/svg/editsvg.svg";
import { ReactComponent as Previewsvg } from "assets/svg/previewsvg.svg";
import { ReactComponent as Block } from "assets/svg/block.svg";
import { ReactComponent as UnBlock } from "assets/svg/unblock.svg";
import usePermissions from "hooks/usePermissions";

const TableActions = ({
  viewLink,
  editLink,
  deleteHandler,
  viewHandler,
  blockHandler,
  isItemBlocked = false,
  permissionKey = "",
}) => {
  const permission = usePermissions({ permissionKey });
  const canView = permissionKey ? permission.isView : true;
  const canAdd = permissionKey ? permission.isAdd : true;
  const canDelete = permissionKey ? permission.isDelete : true;
  return (
    <div className="action_btns d-flex align-items-center gap-3">
      {canView && viewLink && (
        <Link to={viewLink}>
          <Button className="btn_action">
            <Previewsvg />
          </Button>
        </Link>
      )}
      {canView && viewHandler && (
        <span onClick={viewHandler}>
          <Button className="btn_action">
            <Previewsvg />
          </Button>
        </span>
      )}
      {canAdd && editLink && (
        <Link to={editLink}>
          <Button className="btn_action">
            <Editsvg />
          </Button>
        </Link>
      )}
      {canDelete && deleteHandler && (
        <Button className="btn_action" onClick={deleteHandler}>
          <Deletesvg />
        </Button>
      )}
      {canAdd && blockHandler && (
        <Button className="btn_action" onClick={blockHandler}>
          {isItemBlocked ? (
            <UnBlock
              style={{
                maxWidth: 18,
                maxHeight: 18,
              }}
            />
          ) : (
            <Block
              style={{
                maxWidth: 20,
                maxHeight: 20,
              }}
            />
          )}
        </Button>
      )}
    </div>
  );
};

export default TableActions;
